;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/sites/:siteId\",\"regex\":\"^/sites/([^/]+)$\",\"paramNames\":[\"siteId\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/login\"},{\"path\":\"/emails\"},{\"path\":\"/sites\"},{\"path\":\"/sentry-test\"},{\"path\":\"/ui-demo\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.0.10";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,

  // Release & Environment: Automatically injected by @sentry/nextjs at build time
  // Do NOT set 'release' explicitly - the webpack plugin handles this correctly
  // for both server and client bundles. Setting it manually breaks client-side
  // release tracking since VERCEL_GIT_COMMIT_SHA is not available in the browser.

  // Performance Monitoring
  tracesSampleRate: 0.1, // 10% for cost control

  // Session Replay - Disabled initially (paid feature)
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,

  // Environment from Vercel
  // MUST use NEXT_PUBLIC_ prefix for browser availability
  // VERCEL_ENV is server-only and undefined in the browser
  environment: process.env.NEXT_PUBLIC_VERCEL_ENV || 'development',
});

// Required for router transition tracking in App Router
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

/**
 * Set user context for error tracking.
 * Call this after successful authentication to attach user info to errors.
 *
 * @example
 * // In auth callback or session provider:
 * import { setSentryUser, clearSentryUser } from '@/instrumentation-client';
 *
 * // On login:
 * setSentryUser({ id: user.id, email: user.email });
 *
 * // On logout:
 * clearSentryUser();
 */
export function setSentryUser(user: {
  id: string;
  email?: string;
  username?: string;
}) {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.username,
  });
}

/**
 * Clear user context on logout.
 */
export function clearSentryUser() {
  Sentry.setUser(null);
}
